import { name2url } from '@/assets/images'
import './index.less'

interface tagBoxProps {
  list: string[]
  imgSrc?: string
}
// 六法列表的标签展示组件
export function TagBox(props: tagBoxProps) {
  const { list } = props

  return (
    <div className='tag-box-container'>
      {list.map((item, index) => (
        <div className='tag-item-container'>
          <div key={index} className='tag-item'>
            {item}
          </div>
          {/*后端拿到src在前端不一定有对应的图。例如，叙述性构图*/}
          {props.imgSrc && name2url[props.imgSrc] ? (
            <img src={name2url[props.imgSrc]} alt={item} />
          ) : null}
        </div>
      ))}
    </div>
  )
}
